import { useMutation } from '@tanstack/react-query';
import { changeVersionContainer } from '../apis';
import { toast } from 'react-toastify';

const useChangeVersion = () => {
  const mutationData = useMutation({
    mutationFn: changeVersionContainer,
    onSuccess: (data) => {
      toast.success('Change version container app successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Change version container app:', error);
    },
  });

  return mutationData;
};

export default useChangeVersion;
